export enum AppFieldKey {
  WorkType                 = 1,
  DOB                      = 2,
  MyIdentity               = 3,
  PersonalDetails          = 4,
  ConnectingInformation    = 5,
  ITSpecialtyScreen        = 6,
  PreferredLocation        = 7,
  Connections              = 8,
  ITSkills                 = 9,
  TellUsAboutYou           = 10,
  UserProfile              = 11,
  CompanyCountSelection    = 12,
  PreferredITSpecialties   = 13,
  PreferredITSkills        = 14,
  ExperienceRange          = 15,
  Gender                   = 16,
  PreferredExperienceRange = 17,
  PreferredWorkType        = 18,
  AvailabilityType         =19,
  ExploreTechnologies                 =20,

}

